import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  return format(date, 'dd MMM, yyyy');
}

export function formatHours(hours: number): string {
  return `${hours}h`;
}

export function formatPercentage(percentage: number): string {
  return `${percentage}%`;
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'in_progress':
      return 'bg-amber-500';
    case 'on_hold':
      return 'bg-blue-500';
    case 'done':
      return 'bg-emerald-500';
    default:
      return 'bg-slate-500';
  }
}

export function getChangeIndicator(change: number) {
  if (change > 0) {
    return {
      color: 'text-emerald-500',
      icon: 'triangle',
      text: `+${change}`,
    };
  } else if (change < 0) {
    return {
      color: 'text-red-500',
      icon: 'triangle',
      text: change.toString(),
    };
  } else {
    return {
      color: 'text-slate-500',
      icon: 'minus',
      text: '0',
    };
  }
}